import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { thunk } from 'redux-thunk';
import appReducer from "./app/reducer.js";
import ordersReducer from "./orders/reducer.js";
import crmSettingsReducer from "./crmSettings/reducer.js";

// Reducer function to handle state changes
const rootReducer = combineReducers({
  app: appReducer,
  orders: ordersReducer,
  crmSettings: crmSettingsReducer
})

const middleware = [thunk];

// Create the Redux store
const store = createStore(rootReducer, {}, compose(
  applyMiddleware(...middleware),
  window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f // for Redux DevTools
));

export default store;